import { MaterialSymbol } from '@florencelabs/icons';
import Link from 'next/link';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { AppointmentSummary } from '@provider-directory/components/appointment-summary/appointment-summary.component';
import { SplitScreen } from '@provider-directory/components/split-screen/split-screen.component';
import { useAppointment } from '@provider-directory/contexts/AppointmentContext';
import { useOrgContext } from '../org-context/org-context-provider';

export default function Confirm(): ReactElement {
  const { t } = useTranslation();
  const { appointment } = useAppointment();
  const { getProvidersUrl } = useOrgContext();

  return (
    <SplitScreen
      isOriginalOrder={true}
      additionalClassnames={{
        left: {
          children:
            'px-6 pt-6 tablet:px-16 tablet:pb-0 desktop:p-0 desktop:pt-10 desktop:pr-10',
        },
        right: {
          children: 'desktop:max-w-[584px]',
          screen: 'bg-transparent bg-none desktop:pt-[131px] desktop:!pl-2',
        },
      }}
    >
      <div
        data-testid={'appointment-confirm'}
        className={'flex w-full flex-col items-start'}
      >
        <Link
          href={getProvidersUrl()}
          data-testid={'home-btn'}
          className={
            'mb-6 flex items-center gap-1 text-body-medium-semibold desktop:mb-14 print:hidden'
          }
        >
          <MaterialSymbol name={'chevron_left'} size={20} />
          {t('schedule.home')}
        </Link>
        <MaterialSymbol
          data-testid={'check-circle'}
          name={'check_circle_fill'}
          size={40}
          className={'mb-4 text-green-700'}
        />
        <h1
          data-testid={'confirm-page-title'}
          className={
            'pb-2 font-serif text-display-large desktop:text-display-xlarge'
          }
        >
          {t('schedule.confirmAppointment')}
        </h1>
        <div
          data-testid={'confirm-appointment-message'}
          className={'text-body-medium'}
        >
          {t('schedule.confirmationEmailMessage')}
          <p className={'text-body-medium-semibold'}>{appointment.email}</p>
        </div>
      </div>
      <AppointmentSummary />
    </SplitScreen>
  );
}
